import styled from "styled-components";

export const QwacFileUploadedWrapper = styled.div`
    padding-top: 25px;
`;
